import { useTextes } from '@common/config';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const Z_JOB = Z_TEXT(t['ADM_MES5'])
  .max(200);

export const JOB_PLACEHOLDER = 'Comptable';